import { humanize, PrmService, toSentence, User } from '../gs-core/common';
import { CurrentUserService } from '../gs-core/client';

import {
  ActionType, EDocsPermissions, PermissionEvaluator, SearchScope, Subject, SubjectModel, SubjectType, SubjectTypes
} from '../common/models';

export interface SubjectSelection {
  selectedSubject: Subject;
  allSubjects: Subject[];
}

export class SubjectService {
  constructor(
    private prmService: PrmService,
    private currentUserService: CurrentUserService
  ) {}

  findSelection = async (
    userId: number,
    type: SubjectType = SubjectTypes.STUDENT
  ): Promise<SubjectSelection | undefined> => {
    const user = await this.prmService.findUser(userId);
    const allSubjects = SubjectModel.createMultipleFrom(user);

    if (!allSubjects.length) {
      return undefined;
    }

    const selectedSubject = allSubjects.find(subject => subject.type === type) || allSubjects[0];
    return { selectedSubject, allSubjects };
  };

  findSearchScope = async (actionType: ActionType, subjectType?: SubjectType) => {
    const currentUser = await this.currentUserService.find();

    if (!currentUser) {
      throw new Error('Unable to find current user');
    }

    const actions = EDocsPermissions.fromAction(actionType, subjectType);
    const permissions = await this.currentUserService.findPermissions();

    return PermissionEvaluator
      .forUser(currentUser as User)
      .withPermissions(permissions)
      .findSearchScope(actions);
  };

  toPlaceholder = (searchScope: SearchScope) => {
    const subjectTypes = Object.keys(searchScope.roleMap).map(role => SubjectTypes.fromRole(role));

    return toSentence(humanize(subjectTypes), undefined, 'or').toLowerCase();
  };

  search = async (searchText: string, searchScope: SearchScope): Promise<User[]> => {
    if (searchScope) {
      return this.prmService.search( searchText, { ...searchScope } );
    }

    return [];
  };
}



// WEBPACK FOOTER //
// ./src/services/SubjectService.ts